import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  componentDidCatch(error) {
    this.setState({ error });
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E] p-8 text-center">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-bronze">461 Beechwood</p>
            <p className="mt-4 text-lg text-white">Something went wrong on this page.</p>
            <button
              onClick={() => this.setState({ error: null })}
              className="mt-6 rounded-full bg-white px-6 py-2 text-sm font-semibold text-zinc-900"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
